import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"
import { ReviewPeriodService } from "@/services/ReviewPeriodService"

export const getUnderReviewPeriods = (accountNumber: string) => {
  const queries = new QueryAggregator()
  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  const underReviewPeriodsQuery = ReviewPeriodService.getForAccount(
    coreIdQuery.data,
  )

  queries.add(coreIdQuery)
  queries.add(underReviewPeriodsQuery)

  return queries.setData(underReviewPeriodsQuery.data).getAggregate()
}
